import React from 'react';
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
} from '@chakra-ui/react';
import { useIntl } from 'react-intl';

const StoreHoursTable = ({ hoursOnline, hoursDefault, hoursRows }) => {
    const intl = useIntl();

    if (!hoursOnline || !hoursDefault || !hoursRows || hoursRows.length === 0) {
        return null;
    }

    return (
        <TableContainer>
            <Table variant='simple'>
                <Thead>
                    <Tr>
                        <Th>{intl.formatMessage({ id: 'plp.storeSelector.stores.time.regular', defaultMessage: 'Regular' })}</Th>
                        <Th>{intl.formatMessage({ id: 'plp.storeSelector.stores.time.open', defaultMessage: 'Open' })}</Th>
                        <Th>{intl.formatMessage({ id: 'plp.storeSelector.stores.time.close', defaultMessage: 'Close' })}</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {hoursRows?.map((item, index) => (
                        <Tr key={index}>
                            <Td>{item?.split('|')[0]?.trim()}</Td>
                            <Td>{item?.split('|')[1]?.trim()}</Td>
                            <Td>{item?.split('|')[2]?.trim()}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    );
};

export default StoreHoursTable;